import React, { useState, useEffect } from 'react'
import application from '@config/application'
import { useHistory } from 'react-router-dom'
import Cookies from 'js-cookie'
import {
  IconButton,
  Badge,
  Avatar, Button, Menu, MenuItem, makeStyles,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Divider,
} from '@material-ui/core'
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone'
import icons from '@assets/icons'
import { resellerApiWithToken } from '@api/baseApi'
import * as dayjs from 'dayjs'
import 'dayjs/locale/id'

const useStyles = makeStyles((theme) => ({
  menu: {
    '& svg': {
      marginRight: '1rem',
    },
  },
  iconButton: {
    margin: '0px 8px 0px 8px',
    '& .MuiBadge-colorPrimary': {
      color: '#E66A57',
      background: '#fff',
    },
  },
  notification: {
    width: 340,
    borderRadius: 5,
    marginTop: 60,
    marginLeft: -150,
    border: 'solid 0.5px #cccccc',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: 8,
    },
    '&::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.3)',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 10,
      backgroundColor: 'RGBA(85,111,181,0.6)',
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 'auto',
    },
  },
  listItem: {
    position: 'relative',
  },
  secondaryText: {
    '&.MuiTypography-root': {
      '&.MuiListItemText-secondary': {
        color: 'red',
      },
    },
  },
}))

const HeaderMenu = () => {
  const classes = useStyles()
  const history = useHistory()
  const [anchorEl, setAnchorEl] = useState(null)
  const [anchorEl2, setAnchorEl2] = useState(null)
  const [menuOpen, setMenuOpen] = useState(false)
  const [notifications, setNotifications] = useState([])
  const [countNotif, setCountNotif] = useState(0)
  const name = JSON.parse(localStorage.getItem('payload'))?.name || ''
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const getNotificationList = async () => {
    const api = '/affiliates/notifications'

    try {
      const {
        status,
        data: { data, unread },
      } = await resellerApiWithToken.get(api)

      if (status === 200) {
        setNotifications(data)
        setCountNotif(unread)
      } else {
        setNotifications([])
      }
    } catch (error) {
      setNotifications([])
    }
  }

  useEffect(() => {
    getNotificationList()
  }, [])

  const handleClose = () => {
    setAnchorEl(null)
  }

  const onLogout = () => {
    Cookies.remove('affiliate_app_token')
    localStorage.clear()
    history.push(`${application.prefix}/affiliate`)
  }
  const handleClose2 = () => {
    setMenuOpen(!menuOpen)
    setAnchorEl2(null)
  }
  const action = (url) => {
    if (url) history.push(url)
    setMenuOpen(!menuOpen)
    setAnchorEl2(null)
  }
  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget)
  }
  const renderNotificationMenu = () => (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl2}
      keepMounted
      open={Boolean(anchorEl2)}
      onClose={handleClose2}
      elevation={0}
      classes={{
        paper: classes.notification,
      }}
    >
      <List>
        {
          notifications.map((item) => (
            <div key={item.id}>
              <ListItem
                button
                onClick={() => action(item.action, item.id)}
                className={classes.listItem}
              >
                <ListItemIcon>
                  <img
                    src={icons.CircleGroup}
                    alt="circle group"
                    height={48}
                    width={48}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={item.has_read ? item.title : <strong>{item.title}</strong>}
                  secondary={(
                    <Typography
                      noWrap
                      variant="subtitle2"
                      gutterBottom
                    >
                      {item.has_read ? item.message : <strong>{item.message}</strong>}
                    </Typography>
                )}
                  variant="caption"
                  className={classes.secondaryText}
                />
                <Typography className={classes.notificationTime}>
                  {dayjs(item.created_at)
                    .locale('id')
                    .format('DD MMMM YYYY, HH:mm')}
                </Typography>
              </ListItem>
              <Divider />
            </div>
          ))
        }
        <Button fullWidth onClick={() => history.push(`${application.basePath}/notifications`)}>
          Lihat Semua
        </Button>
      </List>
    </Menu>
  )

  return (
    <div style={{ width: 300, display: 'flex', alignItems: 'center' }}>
      <IconButton
        className={classes.iconButton}
        color="primary"
        onClick={handleClick2}
      >
        <Badge variant="standard" color="primary" badgeContent={countNotif}>
          <NotificationsNoneIcon style={{ color: '#fff' }} />
        </Badge>
      </IconButton>
      {renderNotificationMenu()}
      <Button
        startIcon={<Avatar />}
        onClick={handleClick}
        style={{ color: 'white' }}
      >
        {name}
      </Button>
      <Menu
        className={classes.menu}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        PaperProps={{
          style: { width: 200 },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <MenuItem onClick={onLogout}>
          <span style={{ color: '#E82A63' }}>Logout</span>
        </MenuItem>
      </Menu>

    </div>

  )
}
export default HeaderMenu
